/** Reserved album IDs. Values match the backend AlbumId enum. */
export const ALBUM_ID = {
    /** Main (unnamed) photo gallery — always the first section. */
    MAIN: '_main',
};

export const EDITOR_STATUS = {
    AWAITING_USER_INPUT: 1,
    SAVING: 2,
    DONE: 3
}

/** Order (reservation) status. Values match backend OrderStatus enum. */
export const RESERVATION_STATUS = {
    DRAFT: 'DRAFT',
    PENDING_PAYMENT: 'PENDING_PAYMENT',
    CONFIRMED: 'CONFIRMED',
    CANCELLED: 'CANCELLED',
}

/** Display labels for reservation statuses. */
export const RESERVATION_STATUS_LABELS = {
    [RESERVATION_STATUS.DRAFT]: 'Draft',
    [RESERVATION_STATUS.PENDING_PAYMENT]: 'Pending payment',
    [RESERVATION_STATUS.CONFIRMED]: 'Confirmed',
    [RESERVATION_STATUS.CANCELLED]: 'Cancelled',
}

//Price Modifiers
export const MODIFIER_TYPES = {
    ALL_THE_TIME: 'ALL_THE_TIME',
    DAY_OF_WEEK: 'DAY_OF_WEEK',
    LENGTH_OF_STAY: 'LENGTH_OF_STAY',
    NUMBER_OF_GUESTS: 'NUMBER_OF_GUESTS',
}

export const ADJUSTMENT_TYPES = {
    PERCENTAGE: 'PERCENTAGE',
    FIXED_AMOUNT: 'FIXED_AMOUNT'
}

export const COMPARISON_OPERATORS = {
    LESS_THAN: 'LESS_THAN',
    LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
    EQUAL: 'EQUAL',
    GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
    GREATER_THAN: 'GREATER_THAN'
}

export const ADJUSTMENT_SCOPES = {
    DAY: 'DAY',
    TOTAL: 'TOTAL'
}

export const ORDER_STATUS = {
    DRAFT: 'DRAFT',
    PENDING_PAYMENT: 'PENDING_PAYMENT',
    CONFIRMED: 'CONFIRMED',
    CANCELLED: 'CANCELLED',
}